import React from 'react';
import DataTableNPM from 'react-data-table-component';
import DataTableLoader from './loader';

const DataTable = (props) => {
  const { loading } = props;
  
  if (loading) {
    return <DataTableLoader {...props} />;
  }
  
  return(
    <div style={{ position: 'relative' }}> 
      <DataTableNPM
        {...props}
      />
    </div>
  );
};

export default DataTable;